import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import { Recipient } from 'api/api';

import { useGlobalState } from '~src/global-state';

import { Autocomplete } from '~address-form/inputs/autocomplete/autocomplete';
import { complementAddress } from '~address-form/utils/format';

import { GridItemWrapper } from '../components/grid-item-wrapper';
import { AddressFormFields } from '../types';

interface StreetNameAndNumberFieldProps {
  onPlaceSelect: (address: Recipient) => void;
  invalidComponents?: string[];
}

export const AutocompleteField: React.FC<StreetNameAndNumberFieldProps> = ({
  onPlaceSelect,
  invalidComponents,
}) => {
  const globalState = useGlobalState();

  const { reset, getValues } = useFormContext<AddressFormFields>();

  return (
    <GridItemWrapper>
      <Autocomplete
        onPlaceSelect={(values: Recipient) => {
          const address = complementAddress(values, globalState.purchase_country);
          reset({
            ...getValues(),
            ...address,
          });
          onPlaceSelect(address);
        }}
        warning={invalidComponents?.includes('ADDRESS_LINES')}
      />
    </GridItemWrapper>
  );
};
